import { useCurrentStateAndParams } from "@uirouter/react";

import { SELECTED_TAB_QUERY_PARAM } from "single-spa/react-app/config/solutions25/industryResearchConfig";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { WithAnimationContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/WithAnimationContainer";

import { WebsiteRankingsTabs } from "../../website-rankings/WebsiteRankingsTabs";
import { ECategoryLeadersMetricType } from "../CategoryLeaders.types";
import { CategoryLeadersPage } from "../components/CategoryLeadersPage/CategoryLeadersPage";

import { CategoryLeadersSearchTableTop } from "./CategoryLeadersSearchPage/CategoryLeadersSearchTableTop";

const tableHeaderWithPaidOrganicFilter = CategoryLeadersSearchTableTop;

// Tabs not listed here (GenAi, Affiliates, etc.) intentionally fall back to the
// default CategoryLeadersTableTop via CategoryLeadersPage's default prop, since
// they don't need the Paid/Organic filter.
const tableHeaders = {
    [ECategoryLeadersMetricType.CategoryLeadersSearch]: tableHeaderWithPaidOrganicFilter,
    [ECategoryLeadersMetricType.CategoryLeadersSocial]: tableHeaderWithPaidOrganicFilter,
};

type Params = {
    [SELECTED_TAB_QUERY_PARAM]: keyof typeof ECategoryLeadersMetricType;
};

export const TrafficAcquisitionLeaders = () => {
    const { params } = useCurrentStateAndParams<Params>();
    let selectedTab: ECategoryLeadersMetricType;

    if (params[SELECTED_TAB_QUERY_PARAM]) {
        const paramValue = params[SELECTED_TAB_QUERY_PARAM];
        selectedTab = ECategoryLeadersMetricType[paramValue];
    } else {
        selectedTab = ECategoryLeadersMetricType.CategoryLeadersSearch;
    }
    const TableHeaderComponent = tableHeaders[selectedTab];

    return (
        <FlexColumn gap="24px">
            <WebsiteRankingsTabs selectedTabId={selectedTab} />
            <WithAnimationContainer>
                <CategoryLeadersPage
                    key={selectedTab}
                    metricType={selectedTab}
                    TableHeaderComponent={TableHeaderComponent}
                />
            </WithAnimationContainer>
        </FlexColumn>
    );
};
